export default {
  review: "review",
  pending: "pending",
  success: "success",
  error: "error"
};



// WEBPACK FOOTER //
// ./src/util/requestStatuses.js